<template>
  <div class="locations-map">
    <div class="locations-map__filter" v-if="brands">
      <span class="locations-map__filter-item locations-map__filter-item--label">
        Zobrazit:
      </span>
      <label
          v-for="brand in brands"
          :key="brand.slug"
          class="locations-map__filter-item">
        <input
            type="checkbox"
            name="locations-map-filter"
            v-model="filter"
            :value="brand.slug">
        <span class="locations-map__filter-label">
          {{ brand.name }}
        </span>
      </label>
    </div>

    <div class="locations-map__container">
      <gmap-map
          v-if="locations"
          class="locations-map__canvas"
          ref="map"
          :options="mapOptions"
          :center="{ lat: 49.8037633, lng: 15.4749126 }"
          :zoom="zoomLevel">

        <gmap-info-window
            :options="infoOptions"
            :position="infoWindowPos"
            :opened="infoWindowOpen"
            @closeclick="infoWindowOpen = false">
          <span v-if="currentMarkerData">
            <p class="locations-map__info">
              <strong>{{ currentMarkerData.title }}</strong><br>
              {{ currentMarkerData.address }}
            </p>
            <a class="locations-map__button"
               :href="`https://www.google.com/maps/dir/?api=1&destination=${currentMarkerData.location.lat},${currentMarkerData.location.lng}`" target="_blank">
              Navigovat
            </a>
          </span>
        </gmap-info-window>

        <gmap-cluster
            zoom-on-click
            :styles="clusterStyles">
          <gmap-marker
              v-for="(marker, index) in filteredLocations"
              :key="index"
              :icon="marker.brand.icon"
              @click="toggleInfoWindow(marker, index)"
              :position="{ lat: parseFloat(marker.location.lat), lng: parseFloat(marker.location.lng) }"/>
        </gmap-cluster>
      </gmap-map>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  import 'babel-polyfill'
  import './plugins/vue-google-maps'
  import axios from 'axios'

  export default {
    name: 'locations-map',
    props: {
      locationsType: {
        type: String
      },
      zoom: {
        type: Number,
        default: 8
      },
    },
    data () {
      return {
        filter: [],
        brands: null,
        locations: [],
        currentMarkerData: null,
        infoWindowPos: null,
        infoWindowOpen: false,
        currentMarker: null,
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -40
          }
        },
        clusterStyles: [
          {
            textColor: '#fcc875',
            url: 'https://www.prazdroj.cz/cospospohzeg/themes/prazdroj/js/map/assets/cluster--circle-small.png',
            height: 33,
            width: 32,
            fontFamily: 'Cora',
            textSize: 14
          },
          {
            textColor: '#fcc875',
            url: 'https://www.prazdroj.cz/cospospohzeg/themes/prazdroj/js/map/assets/cluster--circle-medium.png',
            height: 50,
            width: 49,
            fontFamily: 'Cora',
            textSize: 18
          },
          {
            textColor: '#fcc875',
            url: 'https://www.prazdroj.cz/cospospohzeg/themes/prazdroj/js/map/assets/cluster--circle.png',
            height: 72,
            width: 68,
            fontFamily: 'Cora',
            textSize: 20
          }
        ],
        mapOptions: {
          mapTypeControl: false,
          fullscreenControl: false,
          streetViewControl: false,
          styles: [
            {
              'featureType': 'administrative',
              'elementType': 'labels.text.fill',
              'stylers': [
                {
                  'color': '#0f5911'
                }
              ]
            },
            {
              'featureType': 'landscape',
              'elementType': 'all',
              'stylers': [
                {
                  'color': '#cbcbcb'
                }
              ]
            },
            {
              'featureType': 'poi',
              'elementType': 'all',
              'stylers': [
                {
                  'visibility': 'off'
                }
              ]
            },
            {
              'featureType': 'road',
              'elementType': 'all',
              'stylers': [
                {
                  'saturation': -100
                },
                {
                  'lightness': 45
                }
              ]
            },
            {
              'featureType': 'road.highway',
              'elementType': 'all',
              'stylers': [
                {
                  'visibility': 'simplified'
                }
              ]
            },
            {
              'featureType': 'road.arterial',
              'elementType': 'labels.icon',
              'stylers': [
                {
                  'visibility': 'off'
                }
              ]
            },
            {
              'featureType': 'transit',
              'elementType': 'all',
              'stylers': [
                {
                  'visibility': 'off'
                }
              ]
            },
            {
              'featureType': 'water',
              'elementType': 'all',
              'stylers': [
                {
                  'color': '#f2f0ee'
                },
                {
                  'visibility': 'on'
                }
              ]
            }
          ]
        }
      }
    },

    computed: {
      zoomLevel () {
        if (window.matchMedia('(min-width: 1080px)').matches) {
          return this.zoom
        } else if (window.matchMedia('(min-width: 768px)').matches) {
          return this.zoom - 1
        } else {
          return this.zoom - 2
        }
      },

      typeQuery () {
        return this.locationsType ? `?przd_location_type=${this.locationsType}` : ''
      },

      filteredLocations () {
        if (this.filter) {
          return this.locations.filter(location => this.filter.includes(location.brand.slug))
        } else {
          return this.locations
        }
      }
    },

    mounted () {
      axios.get(`https://www.prazdroj.cz/wp-json/przd/v1/brands/${this.typeQuery}`).then(brands => {
        this.brands = brands.data
        this.filter = this.brands.map(item => item.slug)
      })
      axios.get(`https://www.prazdroj.cz/wp-json/przd/v1/locations/${this.typeQuery}`).then(locations => {
        this.locations = locations.data
      })
    },

    methods: {
      toggleInfoWindow (marker, index) {
        const {lat, lng} = marker.location
        this.infoWindowPos = {lat: parseFloat(lat), lng: parseFloat(lng)}
        this.currentMarkerData = marker
        if (this.currentMarker === index) {
          this.infoWindowOpen = !this.infoWindowOpen
        } else {
          this.infoWindowOpen = true
          this.currentMarker = index
        }
      }
    }
  }
</script>

<style scoped>
  .locations-map__container {
    position: relative;
    width: 100%;
    height: 0;
    padding-top: 100%;
    background: #969696;
  }

  @media screen and (min-width: 37.5em) {
    .locations-map__container {
      padding-top: 80vh;
    }
  }

  @media (max-width: 37.5em) and (orientation: portrait) {
    .locations-map__container {
      padding-top: 150%;
    }
  }

  .locations-map__canvas {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  .locations-map__filter {
    padding: 16px 6.5%;
    display: flex;
    flex-wrap: wrap;
  }

  @media screen and (min-width: 37.5em) {
    .locations-map__filter {
      text-align: center;
      display: block;
    }
  }

  .locations-map__filter-item {
    font-family: 'Roboto', sans-serif;
    cursor: pointer;
    width: 50%;
  }

  @media screen and (min-width: 37.5em) {
    .locations-map__filter-item {
      display: inline-block;
      width: auto;
      margin-right: 16px;
    }
  }

  .locations-map__filter-item--label {
    display: block;
    width: 100%;
    margin-bottom: 24px;
  }


  @media screen and (min-width: 37.5em) {
    .locations-map__filter-item--label {
      display: inline-block;
      width: auto;
      margin-bottom: 0;
    }
  }

  .locations-map__button {
    display: inline-block;
    padding: 6px 15px 5px 15px;
    font-family: 'Cora', sans-serif;
    font-size: 1.2rem;
    font-weight: bold;
    text-decoration: none;
    text-transform: uppercase;
    background: transparent;
    color: #c09a51;
    border: none;
    border-top: 2px solid #c09a51;
    border-bottom: 2px solid #c09a51;
    border-radius: 0;
  }

  .locations-map__button:hover {
    background: #c09a51;
    color: #fff;
  }

  .locations-map__info {
    margin-top: 0;
  }

  >>> .gm-style-iw {
    width: 220px!important;
  }
</style>
